export const AgreementSign = `<br><br>
<p class="long-text" style="color: #000000; font-size: 19px; line-height: 24px; font-family: Arial-Regular;">
    <span style="font-weight: 800; font-family: Helvetica-bold;"> IN WITNESS WHEREOF,</span> the undersigned have executed and delivered this Agreement.</p> 
    <table style="width:100%">
        <tr style="height: 30px; vertical-align: top">
            <td style="width:19%">Company:</td>
            <td width:50% style="font-weight: 700; "width:31%;">Buy Box Experts</td>
            <td> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td style="width:19%">Company:</td>
            <td style="font-weight: 700; "width:31%;">CUSTOMER_NAME</td>
        </tr>
         <tr style="height: 30px; vertical-align: top">
            <td>Signature:</td>
            <td style="font-weight: 700;">THAD_SIGN</td>
            <td></td>
            <td>Signature:</td>
            <td style="font-weight: 700;"><span style="padding: 4px 9px; font-weight: bold";>{{Signature*}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
        </tr>
        <tr style="height: 30px; vertical-align: top">
            <td width:50%>Printed Name:</td>
            <td width:50% style="font-weight: 700;">PRINTED_NAME</td>
            <td></td>
            <td width:50%>
                Printed Name:
            </td width:50%>
            <td style="font-weight: 700;">
                {{Fullname}}
            </td>
        </tr>
        <tr style="height: 30px; vertical-align: top">
            <td>Title:</td>
            <td style="font-weight: 700;">
             TITLE
            </td>
            <td></td>
            <td>Title:</td>
            <td style="font-weight: 700;">
              {{Jobtitle}}
            </td>
        </tr>
        <tr style="height: 30px; vertical-align: top">
            <td>Date:</td>
            <td style="font-weight: 700;">BBE_DATE</td>
            <td></td>
            <td>Date:</td>
            <td style="font-weight: 700;"><span style="padding: 4px 9px; font-weight: bold";>{{Signdate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
        </tr>
        <tr style="height: 30px; vertical-align: top">
            <td>Address:</td>
            <td style="font-weight: 700;">PO Box 1010 Riverton, UT 84065</td>
            <td></td>
            <td>Address:</td>
            <td style="font-weight: 700;">CUSTOMER_ADDRESS</td>
        </tr>
    </table>`;

export const AddendumSign = `<br><br> <p>CONTRACT_ADDENDUM_CHANGES</p>
<p class="long-text " style="color: #000000;
        font-size: 19px;
        line-height: 24px;
        font-family: Arial-Regular;"><span style="font-weight: 800;
        font-family: Helvetica-bold;"> IN WITNESS WHEREOF,</span> the undersigned have executed and delivered this Agreement.
    </p>
    <table style="width:100%">
        <tr style="height: 30px; vertical-align: top">
            <td style="width:19%">Company:</td>
            <td style="font-weight: 700; "width:31%;">Buy Box Experts</td>
            <td> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;</td>
            <td style="width:19%">Company:</td>
            <td style="font-weight: 700;"width:31%">CUSTOMER_NAME</td>
        </tr>
         <tr style="height: 30px; vertical-align: top">
            <td>Signature:</td>
            <td style="font-weight: 700;" >THAD_SIGN</td>
            <td></td>
            <td>Signature:</td>
            <td style="font-weight: 700;"><span style="padding: 4px 9px; font-weight: bold";>
            {{Signature*}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
        </tr>
        <tr style="height: 30px; vertical-align: top">
            <td>Printed Name:</td>
            <td style="font-weight: 700;">PRINTED_NAME</td>
            <td></td>
            <td>Printed Name:</td>
            <td style="font-weight: 700;">{{Fullname}}</td>
        </tr>      
        <tr style="height: px; vertical-align: top">
            <td>Date:</td>
            <td style="font-weight: 700;">BBE_DATE</td>
            <td></td>
            <td>Date:</td>
            <td style="font-weight: 700;"><span style="padding: 4px 9px; font-weight: bold";>{{Signdate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
        </tr>      
    </table>`;

export const RecurringLanguage = `Opportunity to Cure:  In the event that either Party (the "Notifying Party") believes that the other Party (the "Responding Party") is in breach of a material term of this Agreement, the Responding Party shall have thirty (30) days from receipt of written notice from the Notifying Party to cure the breach. Upon initiating the 30 day cure period, the Parties shall mutually agree in good faith to an objective standard by which to measure whether the breach has been cured prior to the end of the 30 day period. If at the end of the 30 days, the objective criteria have not been met, then the Notifying Party may terminate this Agreement.`;

export const Recurring90DaysLanguage = `90 Day Notice:  Either Party may terminate this Agreement at any time with 90 days prior written notice to the other Party.  Unless the Parties agree otherwise, this Agreement shall terminate at the end of the 90 day period; provided that, the covenants in this Agreement which are intended to survive termination shall continue to be in effect as set forth herein.`;
